import React from 'react';
import { ICON_NAMES, resolveIcon } from '../../utils/iconCatalog';

interface IconPickerProps {
  value?: string;
  onChange: (iconName: string) => void;
}

const IconPicker: React.FC<IconPickerProps> = ({ value, onChange }) => {
  return (
    <div className="grid grid-cols-8 gap-2 p-2 border border-gray-200 rounded-md max-h-40 overflow-y-auto">
      {ICON_NAMES.map((name) => {
        const Icon = resolveIcon(name);
        const active = value === name;
        return (
          <button
            key={name}
            type="button"
            title={name}
            onClick={() => onChange(name)}
            className={`flex items-center justify-center p-2 rounded-md transition-colors ${
              active ? 'bg-primary-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-200'
            }`}
          >
            <Icon className="w-4 h-4" />
          </button>
        );
      })}
    </div>
  );
};

export default IconPicker;
